import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { handleChatAndMessage } from '../../redux/shared/actions.js';
import styles from './QuestionTile.module.css';

function QuestionTile({ question }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const user_id = useSelector((state) => state.user.user_id);
    const messages = useSelector((state) => state.message.messages);
    const model_name = useSelector((state) => state.shared.model_name)

    const handleClick = async () => {
      if (user_id) {
        await dispatch(handleChatAndMessage(user_id, id, question, model_name, messages, navigate));
      }
    }

    return (
      <div className={styles.layout} onClick={handleClick}>
          <p className={styles.question}>{ question }</p>
      </div>    
    );
  }
  
  export default QuestionTile;